import { render, staticRenderFns } from "./MigrationForm.vue?vue&type=template&id=41a36a9d&scoped=true"
import script from "./MigrationForm.vue?vue&type=script&lang=js"
export * from "./MigrationForm.vue?vue&type=script&lang=js"
import style0 from "./MigrationForm.vue?vue&type=style&index=0&id=41a36a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a36a9d",
  null
  
)

export default component.exports